import React from "react";

const Footer = () => {
  return (
    <footer id="footer" className="section bg-dark text-white">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7 text-center text-lg-start wow fadeInUp">
            <p className="mb-2 mb-lg-0">
              Copyright &copy; {new Date().getFullYear()}{" "}
              <a className="fw-600" href="/">
                Justin Grant
              </a>
              . All Rights Reserved.
            </p>
          </div>
          <div className="col-lg-5 text-center text-lg-end wow fadeInUp">
            <p className="mb-0 text-3 opacity-75">
              React front end, Express and MongoDB API, served by nginx.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
